require("-!/home/carlos/projetos/scala/asw-cotacao/ui/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!sass?outputStyle=expanded!/home/carlos/projetos/scala/asw-cotacao/ui/node_modules/bootstrap-sass-loader/bootstrap-sass-styles.loader.js!/home/carlos/projetos/scala/asw-cotacao/ui/bootstrap.config.js");
require("-!/home/carlos/projetos/scala/asw-cotacao/ui/node_modules/bootstrap-sass-loader/bootstrap-sass-scripts.loader.js!/home/carlos/projetos/scala/asw-cotacao/ui/bootstrap.config.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-sass-loader/index.loader.js!./bootstrap.config.js
 ** module id = 270
 ** module chunks = 0
 **/